import { Fragment, useEffect, useState } from 'react';
import { format, add, isAfter } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import find from 'lodash/find';
import useHttp from './useHttp';
import { useStore } from './useStore';
import useBackendSync from './useBackendSync';
import getApiToken from '../utils/getApiToken';

import dataDates from '../dates.json';

const apiToken = getApiToken();

const useAvailability = (month) => {
  const [state, dispatch] = useStore();
  const { error, sendRequest } = useHttp();
  const { appData, initCalendar, selectedDate, section, dateContext, monthChange, totals, calendarType } = state;
  const [eventDates, setEventDates] = useState({});

  useEffect(() => {
    if (error) console.log(error);
  }, [error]);

  const fetchMonth = async (month) => {
    // console.log('fetchMonth', month);
    // console.log('fetchMonth appData', appData);
    // console.log('fetchMonth', dateContext);
    const s = !!section ? section : data.default_ticket_type.post_name;
    // console.log('s', s);
    // console.log(appData.ticket_types[s]['rid']);
    const numPeople = totals.people === 0 ? 1 : totals.people;
    const monthYear = month ? month : dateContext;
    const monthEndpoint = '/wp-json/wbst-booking/v1/all';
    const obj = {
      '_t': apiToken,
      'rid': appData.ticket_types[s]['rid'],
      'qty': numPeople,
      'year': format(monthYear, 'yyyy'),
      'month': format(monthYear, 'M'),
      'etid': appData.ticket_types[s]['evid']
    };
    const events = await sendRequest({
      url: monthEndpoint,
      params: obj
    }, processDates);
    // processDates(dataDates);
    // console.log('fetchMonth', monthYear);
    dispatch('SET', {
      showMonthAvailabilityMessage: false,
      selectedTime: null
    });
  }

  const checkParking = () => {
    // console.log('checking Parking');
    // console.log('selectedDate', selectedDate);
    const parkingObj = find(appData.ticket_types[section]['addons'], (a) => a.title.toLowerCase().includes('parking'));
    // console.log('parkingObj', parkingObj);
    if (parkingObj && selectedDate) {
      const parkingEndpoint = '/wp-json/wbst-booking/v1/day';
      const obj = {
        '_t': apiToken,
        'rid': parseInt(parkingObj.rid),
        'year': format(dateContext, 'yyyy'),
        'month': format(dateContext, 'M'),
        'day': format(dateContext, 'd'),
        'etid': parseInt(parkingObj.evid)
      };
      sendRequest({
        url: parkingEndpoint,
        params: obj
      }, processDay);
    }
  }

  const processDates = (data) => {
    let availDates = {};

    if (data.value.length === 0 && !monthChange && format(dateContext, 'M') < 12) {
      // no events, fetch next month
      const monthNo = format(dateContext, 'M');
      const year = format(dateContext, 'yyyy');
      const nextMonth = new Date(year, monthNo, 1);
      // console.log('fetch next month', nextMonth);
      dispatch('SET', {
        dateContext: nextMonth
      });
      fetchMonth(nextMonth);
    } else if (data.value.length == 0 && monthChange) {
      dispatch('SET', {
        showMonthAvailabilityMessage: true,
        monthChange: false
      });
    } else if (data.value.length > 0) {
      const result = [...data.value];
      // console.log('dates', result);
      if (!initCalendar && calendarType === 'booking') getFirstAvail(result);

      result.forEach(dd => {
        let d = utcToZonedTime(new Date(dd.time), 'UTC');
        let date = format(d, 'yyyy-MM-dd');
        // console.log(date);
        // let time = utcTime(d);
        let time = format(d, 'HH:mm');
        const obj = {
          date: dd.time,
          time: time,
          numAvail: dd.free,
          eventID: dd.eventID
        };
        if (dd.free >= totals.people) {
          if (!Object.keys(availDates).includes(date)) availDates[date] = [];
          availDates[date].push(obj);
        }
      });
      // console.log('availDates', availDates);
      setEventDates(availDates);
      dispatch('SET', {
        eventDates: availDates
      });
    }
  }

  const processDay = (data) => {
    // console.log('parking', data);
    dispatch('SET', {
      hasParking: !!(data.value.length > 0 && data.value[0].free > 0),
      parking: data.value[0]
    });
  }

  const getFirstAvail = (dates) => {
    const firstAvail = find(dates, d => d.free > totals.people);
    const numAvail = firstAvail.free;
    const firstAvailDate = utcToZonedTime(new Date(firstAvail.time), 'UTC');
    // console.log('firstAvailDate', format(firstAvailDate, 'p'));
    dispatch('SET', {
      dateContext: firstAvailDate,
      selectedDate: format(firstAvailDate, 'yyyy-MM-dd'),
      selectedMonth: format(firstAvailDate, 'M'),
      selectedYear: format(firstAvailDate, 'yyyy'),
      selectedTime: format(firstAvailDate, 'p'),
      selectedDateTime: firstAvail.time,
      selectedEvent: firstAvail.eventID,
      dayLimit: numAvail,
      dayMaxed: numAvail === totals.people,
      isCrossSell: false
    });
    checkParking();
  }

  return {
    dateContext,
    eventDates,
    fetchMonth,
    checkParking
  }
};

export default useAvailability;
